import React, { Component } from "react";

import { ReactComponent as LobbyIcon } from "assets/icons/lobby2.svg";
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg";
import { ReactComponent as InfoIcon } from "assets/icons/gameDetails.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as RotateIcon } from "assets/icons/screen-rotate.svg";
import { ReactComponent as HistoryIcon } from "assets/icons/viewHistoryIc.svg";
import { withTranslation } from "react-i18next";

import "./styles.scss";

class GameController extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className={`game-controller ${this.props.gameId}`}>
        <div className="row nopadding flex-nowrap">
          <div
            className="col-auto back"
            data-testid="back-button"
            onClick={() => {
              this.props.onPreviousClick();
            }}
          >
            <PreviousIcon />
          </div>

          <div className="col" />

          {this.props.showInfo && (
            <div
              className="col-auto info"
              data-testid="game-info-button"
              title={t("gameInfo")}
              onClick={() => {
                this.props.toggleInfo();
              }}
            >
              <InfoIcon />
            </div>
          )}
          {this.props.showGameHistory && (
            <div
              className="col-auto game-history"
              data-testid="game-history-button"
              title={t("history")}
              onClick={() => {
                this.props.toggleHistory();
              }}
            >
              <HistoryIcon />
            </div>
          )}
          {this.props.isResponsiveGameDisplayEnabled && (
            <div
              className="col-auto rotate"
              onClick={() => {
                this.props.onRotateClickHandler();
              }}
            >
              <RotateIcon />
            </div>
          )}
          {this.props.showCashier && (
            <div
              className="col-auto cashier"
              data-testid="cashier-icon"
              onClick={this.props.broadcastCashier}
              title={t("cashIn")}
            >
              <CashierIcon />
            </div>
          )}
          {this.props.showSwitchDevice && (
            <div
              className="col-auto"
              data-testid="switch-device-button"
              onClick={() => {
                this.props.broadcastSwitchDevice(
                  this.props.params,
                  this.props.gameId,
                );
              }}
              title={t("switchDevice")}
            >
              <SwitchDevice />
            </div>
          )}
          {this.props.onRefreshClickHandler && (
            <div
              className="col-auto refresh"
              data-testid="reload-button"
              onClick={this.props.onRefreshClickHandler}
              title={t("refresh")}
            >
              <RefreshIcon />
            </div>
          )}
          {this.props.onCloseGameHandler && (
            <div
              className="col-auto lobby"
              data-testid="lobby-button"
              onClick={this.props.onCloseGameHandler}
              title={t("lobby")}
            >
              <span className="badge badge-secondary ">
                <LobbyIcon /> {t("lobby")}
              </span>
            </div>
          )}
          {this.props.onCloseGameHandler && (
            <div
              className="col-auto lobby-mobile"
              data-testid="lobby-button"
              onClick={this.props.onCloseGameHandler}
              title={t("lobby")}
            >
              <LobbyIcon />
            </div>
          )}
          {this.props.onCloseClickHandler && (
            <div
              className="col-auto close"
              data-testid="close-button"
              onClick={this.props.onCloseClickHandler}
              title={t("close")}
            >
              <CloseIcon />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation("translation")(GameController);
